import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { QrCode, ArrowUpRight } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export default function QRCodes() {
  const { activeProperty } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activeProperty) return;
    setLoading(true);
    api
      .get(`/vehicles?property_id=${activeProperty.id}`)
      .then((r) => setRows(r.data || []))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, [activeProperty]);

  const grouped = rows.reduce(
    (acc, v) => {
      (acc[v.status] ||= []).push(v);
      return acc;
    },
    {}
  );

  return (
    <div className="space-y-8">
      <div>
        <div className="mono-tiny text-[#71717A]">QR codes</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-2">
          All QR codes
        </h1>
        <p className="text-[#71717A] text-sm mt-1">
          Click a vehicle to preview, download, share, email, text or print its QR sticker.
        </p>
      </div>

      {loading && <div className="text-sm text-[#71717A]">Loading…</div>}

      {!loading &&
        ["active", "suspended", "pending_payment", "pending_invoice", "inactive", "expired"].map((status) =>
          grouped[status]?.length ? (
            <section key={status}>
              <div className="mono-tiny text-[#71717A] mb-3">
                {status.replace("_", " ")} · {grouped[status].length}
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {grouped[status].map((v) => (
                  <Link
                    key={v.id}
                    to={`/dashboard/qr-codes/${v.id}`}
                    className="group bg-white border border-[#E4E4E7] rounded-lg p-5 hover:shadow-md transition-shadow"
                    data-testid={`qrcard-${v.id}`}
                  >
                    <div className="flex items-center justify-between">
                      <QrCode className="w-5 h-5 text-[#0F8F4F]" strokeWidth={1.5} />
                      <ArrowUpRight className="w-4 h-4 text-[#71717A] group-hover:text-[#0F8F4F]" />
                    </div>
                    <div className="mt-4 font-display font-bold">
                      {v.year} {v.make} {v.model}
                    </div>
                    <div className="mono-tiny text-[#71717A] mt-1">
                      {v.license_plate} · {v.state}
                    </div>
                    <div className="mono-tiny text-[#71717A] mt-3">CODE · {v.qr_code}</div>
                  </Link>
                ))}
              </div>
            </section>
          ) : null
        )}

      {!loading && rows.length === 0 && (
        <div className="text-center py-16 text-[#71717A]">
          No vehicles yet.{" "}
          <Link to="/dashboard/vehicles/new" className="text-[#0F8F4F] font-medium">
            Add one
          </Link>
          .
        </div>
      )}
    </div>
  );
}
